import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];

    const exchange = async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        navigate("/admin", { state: { user: res.data }, replace: true });
      } catch {
        navigate("/admin", { replace: true });
      }
    };
    exchange();
  }, [location, navigate]);

  return (
    <div
      data-testid="auth-callback-screen"
      className="flex min-h-screen flex-col items-center justify-center gap-4 bg-forest text-parchment"
    >
      <Loader2 className="h-8 w-8 animate-spin text-ochre" />
      <p className="font-display text-xl">Entrando na área do lojista...</p>
    </div>
  );
}
